module.exports = __webpack_public_path__ + "img/dots-3.17d83f6a.png";